// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .mapContainer--cFjKY {
  padding-top: 20px;
}

.mapWrapper--nGAh3 {
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/MapChart/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".mapContainer {\n  padding-top: 20px;\n}\n\n.mapWrapper {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapContainer": `mapContainer--cFjKY`,
	"mapWrapper": `mapWrapper--nGAh3`
};
export default ___CSS_LOADER_EXPORT___;
